import './App.css';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import HyperhidrosisSection from './components/HyperhidrosisSection';
import ProcedureSection from './components/ProcedureSection';
import BenefitsSection from './components/BenefitsSection';
import TestimonialsSection from './components/TestimonialsSection';
import InsuranceSection from './components/InsuranceSection';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import WhatsAppFloat from './components/WhatsAppFloat';
import ProgressBar from './components/ProgressBar';
import BackToTop from './components/BackToTop';

function App() {
  return (
    <div className="font-sans">
      <ProgressBar />
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <HyperhidrosisSection />
        <ProcedureSection />
        <BenefitsSection />
        <TestimonialsSection />
        <InsuranceSection />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer />
      <WhatsAppFloat />
      <BackToTop />
    </div>
  );
}

export default App;
